import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import {Link} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import {useHistory} from 'react-router';
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import {date_format, datetime_format} from "../Common/DateFormat";

import {API_URL} from '../constants.js';

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {useTranslation} from "react-i18next";

export function SupplierList(props) {
    const { t } = useTranslation()
    const [Supplieres, setSuppliers] = useState([]);
    const [supplier, setSupplier] = useState(-1);
    const [show, setShow] = useState(false);
    const history = useHistory();
    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);

    const setCurrentSupplier = (supplier) => {
        setSupplier(supplier);
        setShow(true);
    };

    const handleClose = () => setShow(false);

    const deleteSupplier = () => {
        setDisabled(1);
        setIconDisabled(0);
        axios.post(
            API_URL + 'supplier/' + supplier.id + '/delete'
        ).then((response) => {
            if (response.data.status) {
                history.go(0);
                setShow(false);
                alertify.success(response.data.message);
            } else {
                setDisabled(0);
                setIconDisabled(1);
                alertify.error(response.data.message);
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            alertify.error("Something went wrong. Try again!");
        });
    }

    useEffect(() => {

        axios.get(API_URL + 'supplier').then((response) => {
            if (response.data.status) {

                setSuppliers(response.data.data);

                $("#supplier_table").DataTable();
            } else {
                alertify.error(response.data.message);
                return null;
            }
        }).catch((error) => {
            alertify.error("Something went wrong. Try again!");
        });

    }, []);


    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title={t("Supplier List")}>
                            <CardHeaderToolbar>
                                <Link to="/supplier/create" className="btn btn-primary btn-sm mx-3">
                                    {t("Create Supplier")}
                                </Link>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody style={{overflow:'auto'}}>

                            <table id="supplier_table" className="stratprop_datatable table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>{t("SN.")}</th>
                                    <th>{t("Name")}</th>
                                    <th>{t("Phone No")}</th>
                                    <th>{t("Tax No")}</th>
                                    <th>{t("Address")}</th>
                                    <th>{t("Notes")}</th>
                                    <th>{t("Actions")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {Supplieres.length > 0 ? (
                                    Supplieres.map((supplier, index) => (
                                        <tr key={supplier.id}>
                                            <td>{index + 1}</td>
                                            <td>{supplier.name}</td>
                                            <td>{supplier.phone_no}</td>
                                            <td>{supplier.tax_no}</td>
                                            <td>{supplier.address}</td>
                                            <td>{supplier.notes}</td>
                                            <td>
                                                <Link to={`/supplier/edit/${supplier.id}`}
                                                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
                                                    <span className="svg-icon svg-icon-md svg-icon-primary">
                                                          <SVG
                                                              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                          />
                                                    </span>
                                                </Link>
                                                <a
                                                    onClick={() => setCurrentSupplier(supplier)}
                                                    key={supplier.id}
                                                    className="btn btn-icon btn-light btn-hover-danger btn-sm">
                                                    <span className="svg-icon svg-icon-md svg-icon-danger">
                                                      <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>
                                                    </span>
                                                </a>

                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7}>{t("No Supplier")}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Delete Supplier")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("Are you sure you want to Delete?")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("Close")}
                    </Button>
                    <Button variant="primary" onClick={deleteSupplier} disabled={disabled}>
                        {t("Confirm")}
                        <span
                            dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}